import React, { useState } from "react";
import RiskTemplateForm from "./RiskTemplateForm";
import { useTranslation } from "react-i18next";

const AddRiskTemplatePage = () => {
  const { t } = useTranslation();
  const [risks, setRisks] = useState([{ description: "", availability: false, integrity: false, confidentiality: false }]);

  return (
    <div id="content">
      <div id="content-title">{t('add_risk_template')}</div>

      <div className="content-bubble">
        <RiskTemplateForm 
          risks={risks}
          setRisks={setRisks}
        />
      </div>
    </div>
  );
};

export default AddRiskTemplatePage;
